/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, answerSelect, answerError, centerAbsolutely } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : ANSWER : IMAGE 2 : STYLES --------------- ++++++++++ */
export default theme => ({
	image2: {
		borderRadius: pxToEm(10),
		cursor: 'pointer',
		position: 'relative',
		zIndex: '3',
		width: '100%',
		height: '83%',
		'& .graphic': {
			// backgroundImage - dynamic, comes from component which comes from settings
			backgroundColor: theme.color.neutral.dark.swatch,
			backgroundPosition: '50% 0%',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			transition: 'background-image .2s linear 0s',
			borderRadius: 'inherit',
			display: 'inline-block',
			verticalAlign: 'bottom',
			textAlign: 'center',
			position: 'relative',
			width: '100%',
			height: '100%',
			zIndex: '1',
			'& .imageindicator': {
				fontSize: '150%',
				extend: centerAbsolutely
			},
            '&.editable-true.selected-false.valid-false': {
            	extend: answerError.image
            },
			extend: answerSelect
		},
		'&:hover': {
			animationName: 'pulse',
            animationDelay: '0s',
            animationDuration: '.5s'
		}
	}
});
